import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { FeaturesSection } from './components/FeaturesSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    // Small delay to ensure pixel script is loaded
    const timer = setTimeout(() => {
      trackPageView();
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-navy-900 font-body selection:bg-gold-500/30 selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StorySection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <FeaturesSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <HowItWorksSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}